import styled from 'styled-components';
import { baseVariables, toRem } from '@marriott/mi-ui-library';
import { mediaQuery } from '../../../../utils/styles';

export const SinglePropertyContainer = styled.div`
  max-width: 100vw;
  background-color: ${baseVariables.color.neutral10};
  .spo-wrapper {
    padding: ${toRem(64)} ${toRem(16)};
    display: flex;
    justify-content: space-between;
    @media ${mediaQuery.tabletOnly} {
      padding: ${toRem(64)} ${toRem(16)} ${toRem(64)};
    }
    @media ${mediaQuery.mobileOnly} {
      flex-direction: column;
      gap: ${toRem(16)};
      padding: ${toRem(48)} ${toRem(16)} ${toRem(64)};
    }
  }
`;

export const LeftDetails = styled.div`
  width: 45%;
  margin-right: 5%;
  @media ${mediaQuery.mobileOnly} {
    width: 100%;
  }
  .sub-heading {
    margin-top: ${toRem(16)};
    margin-bottom: ${toRem(16)};
    width: ${toRem(150)};
    height: ${toRem(24)};
  }
  .offer-description {
    width: 100%;
    height: ${toRem(16)};
    margin-bottom: ${toRem(5)};
  }
  .terms-and-conditions {
    width: ${toRem(200)};
    height: ${toRem(16)};
    margin-top: ${toRem(27)};
  }
`;
export const RightDetails = styled.div`
  width: 45%;
  @media ${mediaQuery.mobileOnly} {
    width: 100%;
  }
  .sub-heading {
    width: ${toRem(300)};
    height: ${toRem(27)};
    margin-bottom: ${toRem(20)};
    @media ${mediaQuery.mobileOnly} {
      width: ${toRem(300)};
    }
  }
  .offer-description {
    width: 100%;
    height: ${toRem(25)};
    margin: ${toRem(10)} ${toRem(0)};
  }
`;
